import { render } from "./EmptyMessage.vue?vue&type=template&id=3e970754&scoped=true"
import script from "./EmptyMessage.vue?vue&type=script&lang=js"
export * from "./EmptyMessage.vue?vue&type=script&lang=js"

import "./EmptyMessage.vue?vue&type=style&index=0&id=3e970754&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e970754"]])

export default __exports__